<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters" ref="queryForm">

                <el-form-item v-if="accountType!=2">
                    <el-select filterable clearable v-model="filters.userId"
                               placeholder="请选择商户">
                        <el-option
                                v-for="item in merchant"
                                :key="item.userId"
                                :label="item.name"
                                :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.type" clearable placeholder="请选择">
                        <el-option
                                v-for="item in type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <div class="block">
                        <el-date-picker
                                format="yyyy-MM-dd HH:mm:ss"
                                v-model="date"
                                type="datetimerange"
                                placeholder="请选择">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryLog">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportExcel">导出Excel</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="logData" highlight-current-row border stripe v-loading="listLoading"
                  style="width: 100%;text-align: center" @selection-change="selsChange" :row-key="getRowKeys">
            <el-table-column type="index" width="80" label="序号">
            </el-table-column>
            <el-table-column prop="oldMoney" label="账户总金额" :formatter="formatOldMoney" min-width="120">
            </el-table-column>
            <el-table-column prop="userId" label="商家ID" min-width="120">
            </el-table-column>

            <el-table-column prop="money" label="增/减金额" width="150">
                <template slot-scope="scope">

                <span v-if="scope.row.type==1" style="color:red">+{{scope.row.money | formatMoney}}
                </span>
                    <span v-else>-{{scope.row.money | formatMoney}}
                </span>

                </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" :formatter="formatType" width="150">
            </el-table-column>
            <el-table-column prop="reason" label="明细" min-width="120">
            </el-table-column>
            <el-table-column prop="remark" label="订单号备注" min-width="120">
            </el-table-column>
            <el-table-column prop="changTime" label="时间" :formatter="formatTime" width="240">
            </el-table-column>
        </el-table>


        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>
    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    userId: '',
                    type: '',
                    startTime: '',
                    endTime: '',
                },
                accountType: sessionStorage.getItem('type'),
                logData: [],
                merchant: [],
                type: data.type,
                total: 0,
                rowCount: 30,
                pageNO: 1,
                sels: [],
                listLoading: false,
                date: [new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDate(), 0, 0, 0), new Date()]


            }

        },
        mounted: function () {
            let para = {
                userType: 2
            };
            NProgress.start();
            if (this.accountType == 2) {
                this.queryLog();
            } else {
                let url = 'user/getByUserType.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {

                        this.merchant = res.data;
                    }

                }).then(() => {
                    let query = this.$route.query;
                    if (typeof query.userId !== 'undefined') {
                        this.filters.userId = this.$route.query.userId;
                        this.queryLog();
                    } else this.queryLog();
                    NProgress.done();
                });
            }

        },

        activated: function () {

        },

        filters: {
            formatMoney: function (value) {
                if (value)
                    return value / 100 + ' 元';
                else return 0 + "元";
            }
        },

        methods: {


            formatTime: function (row, column) {
                if (row.changeTime)
                    return util.formatDate.format(new Date(row.changeTime), 'yyyy-MM-dd hh:mm:ss ');
            },
            formatType: function (row, column) {
                if (row.type == 0)
                    return '扣除金额';
                else if (row.type == 1)
                    return '获得金额';

            },

            formatMoney: function (row, column) {
                if (row.money) {
                    if (row.type == 0)
                        return `-${row.money / 100}元`;
                    else if (row.type == 1) {
                        return `+${row.money / 100}元`;
                    }
                }

            },
            formatOldMoney: function (row, column) {
                if (row.oldMoney) {
                    return `${row.oldMoney / 100}元`;

                }

            },
            handleCurrentChange(val) {
                this.pageNO = val;
                this.queryLog();
            },

            queryLog() {
                this.listLoading = true;
                var url = "merchantMoneyLog/queryPage.do?t=" + new Date().getTime();
                let para = Object.assign({}, this.filters)
                para.rowCount = this.rowCount;
                para.pageNO = this.pageNO;
                para.startTime = util.formatDate.format(new Date(this.date.toString().split(',')[0]), 'yyyy-MM-dd hh:mm:ss');
                para.endTime = util.formatDate.format(new Date(this.date.toString().split(',')[1]), 'yyyy-MM-dd hh:mm:ss');

                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = res.total;
                        this.logData = res.data;
                    }
                    this.listLoading = false;

                });
            },
            exportExcel:function (index, row) {
                let that = this;

                let para = Object.assign({}, this.filters)
                para.startTime = util.formatDate.format(new Date(this.date.toString().split(',')[0]), 'yyyy-MM-dd hh:mm:ss');
                para.endTime = util.formatDate.format(new Date(this.date.toString().split(',')[1]), 'yyyy-MM-dd hh:mm:ss');

             
                var params = Object.keys(para).map(function (key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(para[key]);
                }).join("&");
             
                window.open(`merchantMoneyLog/queryExport.do?token=${sessionStorage.getItem('token')}&${params}`);
                //this.$refs.exportEx.submit();


            },
            selsChange: function (sels) {
                this.sels = [];
                this.sels = sels;

            }
        }
    }

</script>

<style scoped>
    .el-table th {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// revenueExpenditureAccount.vue?1cadde12